import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="relative z-10 border-t border-border/50 glass backdrop-blur-md">
      <div className="container mx-auto px-4 py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
          {/* Logo and Copyright */}
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Lovers Labs Logo" className="w-8 h-8" width="32" height="32" />
            <span className="text-sm text-muted-foreground mx-px">{t("footer.copyright")}</span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6">
            <Link to="/termsofservice" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {t("footer.termsOfService")}
            </Link>
            <Link to="/privacypolicy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {t("footer.privacyPolicy")}
            </Link>
            <Link to="/dmcapolicy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {t("footer.dmcaPolicy")}
            </Link>
            <Link to="/refund" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {t("footer.refundPolicy")}
            </Link>
            <a
              href="mailto:support@loverslabs.art"
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              {t("footer.contact")}
            </a>
          </div>

          {/* Made with love */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span>{t("footer.madeWith")}</span>
            <Heart className="w-4 h-4 fill-[#FFA51C] text-primary animate-pulse" />
            <span>{t("footer.byTeam")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
